/* eslint-disable */
import { getDeviceType } from '../source/framework/utils/CommonUtils';
const host = window.location.host.replace('www.', '');
const deviceType = getDeviceType();
const developmentDomain = 'autode-dev.de';
const stageDomain = 'autode-stage.de';
const productionDomain = 'auto.de';
const config = {
    development: {
        DOMAIN: developmentDomain,
        // List of headers for every server request.
        headers: {
            'autode-user-device': deviceType
        },
        sentry: 'https://8780e1554e78473580eab5f1338336df@sentry.io/1338136',
        // This keys only for test localhost
        recaptchaSiteKey: '6LdunNEaAAAAAB1DazkKJFN2CbCT7YbMfUZ80R6C',
        recaptchaSecretKey: '6LdunNEaAAAAACDvYVUDZ1_UzX-PCtQK0NrT-iR2',
        // FIREBASE CONFIG
        firebase: {
            apiKey: 'AIzaSyCgAJvoTYoKlt7af5bREhKFS1HP6MAKitw',
            authDomain: 'auto-de-not-production.firebaseapp.com',
            databaseURL: 'https://auto-de-not-production.firebaseio.com',
            projectId: 'auto-de-not-production',
            storageBucket: 'auto-de-not-production.appspot.com',
            messagingSenderId: '930230544692'
        },
        // Hotjar
        hotjar: { hjsv: 6, hjid: 2590373 },
        // Relative URLs — work on any host (localhost, autode-dev.de, auto.de)
        // without hardcoding domain or protocol.
        carsAPI: {
            url: '/service/car-basic-data/api/v1'
        },
        alternativeCarsAPI: {
            url: '/service/car-crawled-data/api/v1',
            ownerId: 'v5EJx8vpkiXBMB5e4eFHuDh8b7A2'
        },
        // FINN (handover v0.6): accident and owner facts only as the source states them — see
        // fe-ui-core-autobahn vehiclesProps/accidentDisclosure. PROD gets FINN's id at the approved rollout.
        strictConditionOwnerIds: ['H3fKgqqlHzfyC2iQmZLrmVmDbVT2'],
        searchAPI: {
            url: '/service/car-search-endpoint/api/v1'
        },
        alternativeSearchAPI: {
            url: '/service/alternatives-search-endpoint/api/v1'
        },
        imagesAPI: {
            imgListUrl: '/service/image-imbo/users',
            imgUrl: 'https://images.autode-dev.de/carimage',
            imgUrlBase: 'https://images.autode-dev.de',
            imgUrlImport: '/service/image-imbo-import'
        },
        profileAPI: {
            url: '/service/user-profile-admin/api/v1'
        },
        userActionsAPI: {
            url: '/service/user-actions/api/v1',
            contactUrl: '/service/user-actions-contact/api/v1'
        },
        invoicesAPI: {
            url: '/service/erp-proxy/api/v1'
        },
        vehicleInfoAPI: {
            url: '/service/car-makemodel-mapping/api/v1'
        },
        imageUploadAPI: {
            url: '/service/image-upload'
        },
        CarPlatformSyncAPI: {
            url: '/service/car-platform-sync/api/v1'
        },
        WpAPI: {
            url: '/wp-json/wp/v2'
        },
        redirectUrl: {
            serviceUnavailable: '/service/fe-main/redirectUrl='
        },
        odooSyncAPI: {
            url: '/service/odoo-sync/api/v1'
        },
        odoo: {
            reqNumber: 'http://10.0.0.5:8069/req/'
        },
        scrapper: {
            url: '/service/scrapper/api/v1/targets/process'
        }
    },
    stage: {
        DOMAIN: stageDomain,
        // List of headers for every server request.
        headers: {
            'autode-user-device': deviceType
        },
        sentry: 'https://ea310e3d5a3b4c25a09de21910adf1b4@sentry.io/1338139',
        // This keys only for test stage server
        recaptchaSiteKey: '6LeYy38UAAAAAFHHq-5QA_9moHuJuJqaAoULDpQE',
        recaptchaSecretKey: '6LeYy38UAAAAAGqA2xLWQNEVFfpHzJ6MHcgOWYyI',
        // FIREBASE CONFIG
        firebase: {
            apiKey: 'AIzaSyCgAJvoTYoKlt7af5bREhKFS1HP6MAKitw',
            authDomain: 'auto-de-not-production.firebaseapp.com',
            databaseURL: 'https://auto-de-not-production.firebaseio.com',
            projectId: 'auto-de-not-production',
            storageBucket: 'auto-de-not-production.appspot.com',
            messagingSenderId: '930230544692'
        },
        // Hotjar
        hotjar: { hjid: 2590373, hjsv: 6 },
        carsAPI: {
            url: `https://www.autode-stage.de/service/car-basic-data/api/v1`
        },
        alternativeCarsAPI: {
            url: 'https://www.autode-stage.de/service/car-crawled-data/api/v1'
        },
        searchAPI: {
            url: `https://www.autode-stage.de/service/car-search-endpoint/api/v1`
        },
        alternativeSearchAPI: {
            url: 'https://www.autode-stage.de/service/alternatives-search-endpoint/api/v1'
        },
        imagesAPI: {
            imgListUrl: `https://www.autode-stage.de/service/image-imbo/users`,
            imgUrl: `https://images.autode-stage.de/carimage`,
            imgUrlBase: `https://images.autode-stage.de`,
            imgUrlImport: 'https://www.autode-stage.de/service/image-imbo-import'
        },
        profileAPI: {
            url: `https://www.autode-stage.de/service/user-profile-admin/api/v1`
        },
        userActionsAPI: {
            url: `https://www.autode-stage.de/service/user-actions/api/v1`,
            contactUrl: 'https://www.autode-stage.de/service/user-actions-contact/api/v1'
        },
        invoicesAPI: {
            url: `https://www.autode-stage.de/service/erp-proxy/api/v1`
        },
        vehicleInfoAPI: {
            url: `https://www.autode-stage.de/service/car-makemodel-mapping/api/v1`
        },
        imageUploadAPI: {
            url: `https://www.autode-stage.de/service/image-upload`
        },
        CarPlatformSyncAPI: {
            url: `https://www.autode-stage.de/service/car-platform-sync/api/v1`
        },
        WpAPI: {
            url: 'https://www.autode-stage.de/wp-json/wp/v2'
        },
        redirectUrl: {
            serviceUnavailable: 'https://www.autode-stage.de/service/fe-main/redirectUrl='
        }
    },
    production: {
        DOMAIN: productionDomain,
        // List of headers for every server request.
        headers: {
            'autode-user-device': deviceType
        },
        sentry: 'https://d2fe8cd0ae984485ace1c06ca910bf41@sentry.io/1338140',
        recaptchaSiteKey: '6LdYnNEaAAAAAOZp5uyLlA-k9kOIDYiYsAa4rfFn',
        recaptchaSecretKey: '6LdYnNEaAAAAADui3xYrTZ2tIW_dlBA0tfqBJe4J',
        // FIREBASE CONFIG
        firebase: {
            apiKey: 'AIzaSyB5qwSmpI0uGPRDpVtwpnyUeZclPOAfoZQ',
            authDomain: 'auto-de-production.firebaseapp.com',
            databaseURL: 'https://auto-de-production.firebaseio.com',
            projectId: 'auto-de-production',
            storageBucket: 'auto-de-production.appspot.com',
            messagingSenderId: '1071657931410'
        },
        // Hotjar
        hotjar: {
            hjid: 2590373, hjsv: 6
        },
        // Relative URLs — work on any host without hardcoding domain or protocol.
        carsAPI: {
            url: '/service/car-basic-data/api/v1'
        },
        alternativeCarsAPI: {
            url: '/service/car-crawled-data/api/v1',
            ownerId: 'wGtaGzzBDwdhVc3Bps10FSVwIy02'
        },
        strictConditionOwnerIds: ['ddyCsNeuCqWquthxosMltmepnRW2'],
        searchAPI: {
            url: '/service/car-search-endpoint/api/v1'
        },
        alternativeSearchAPI: {
            url: '/service/alternatives-search-endpoint/api/v1'
        },
        imagesAPI: {
            imgListUrl: '/service/image-imbo/users',
            imgUrl: `https://images.${host}/carimage`,
            imgUrlBase: `https://images.${host}`,
            imgUrlImport: '/service/image-imbo-import'
        },
        profileAPI: {
            url: '/service/user-profile-admin/api/v1'
        },
        userActionsAPI: {
            url: '/service/user-actions/api/v1',
            contactUrl: '/service/user-actions-contact/api/v1'
        },
        invoicesAPI: {
            url: '/service/erp-proxy/api/v1'
        },
        vehicleInfoAPI: {
            url: '/service/car-makemodel-mapping/api/v1'
        },
        imageUploadAPI: {
            url: '/service/image-upload'
        },
        CarPlatformSyncAPI: {
            url: '/service/car-platform-sync/api/v1'
        },
        WpAPI: {
            url: '/wp-json/wp/v2'
        },
        redirectUrl: {
            serviceUnavailable: '/service/fe-main/redirectUrl='
        },
        odooSyncAPI: {
            url: '/service/odoo-sync/api/v1'
        },
        odoo: {
            reqNumber: 'https://odoo.auto.de/req/'
        },
        scrapper: {
            url: '/service/scrapper/api/v1/targets/process'
        }
    }
};
export default config[process.env.NODE_ENV];
/* eslint-enable */
